import { render } from "./ImprintLocation.vue?vue&type=template&id=084a3a31"
import script from "./ImprintLocation.vue?vue&type=script&lang=js"
export * from "./ImprintLocation.vue?vue&type=script&lang=js"

import exportComponent from "/buddy/vue-imprint-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__